import { render } from "./alltotalList.vue?vue&type=template&id=fda9cd94&scoped=true"
import script from "./alltotalList.vue?vue&type=script&lang=js"
export * from "./alltotalList.vue?vue&type=script&lang=js"

import "./alltotalList.vue?vue&type=style&index=0&id=fda9cd94&scoped=true&lang=css"

import exportComponent from "C:\\Users\\USER\\Desktop\\중요\\tcd-cube_opr\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fda9cd94"]])

export default __exports__